import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ButtonTop from "./components/ButtonTop";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Offer from "./components/Offer";
import PriceList from "./components/PriceList";
import Questions from "./components/Questions";
import Slider from "./components/Slider";
import Aboutus from "./components/Aboutus";
import ContactForm from "./components/ContactForm";
import Header from "./components/Header";
import NotFound from "./components/NotFound";
import CookieConsent from "./components/CookieConsent";
import CookiePolicy from "./components/CookiePolicy";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Seo from "./components/Seo";

import "./App.css";

const OrderForm = React.lazy(() => import("./components/OrderForm"));

function App() {
  return (
    <Router>
      <Header />
      <CookieConsent />
      <Routes>
        <Route
          path="/"
          element={
            <div className="App" id="home">
              <Seo
                title="strefadlaedukacji.pl - Legitymacje szkolne, świadectwa i inne materiały dla szkół"
                description="StrefaDlaEdukacji.pl dostarcza legitymacje uczniowskie, legitymacje służbowe nauczycieli, świadectwa i druki szkolne, materiały inne dla placówek oświatowych w Polsce."
                path="/"
              />
              <ButtonTop />
              <Slider />
              <PriceList />
              <Contact />
              <Questions />
              <Footer />
            </div>
          }
        />
        <Route
          path="/offer"
          element={
            <>
              <Seo
                title="strefadlaedukacji.pl - Oferta legitymacji szkolnych, zamawianie, kupowanie"
                description="Sprawdź, jak krok po kroku zamówić legitymacje ucznia lub legitymację służbową nauczyciela w systemie StrefaDlaEdukacji.pl."
                path="/offer"
              />
              <ButtonTop />
              <Offer />
              <PriceList />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/pricing"
          element={
            <>
              <Seo
                title="strefadlaedukacji.pl - Cennik legitymacji, świadectw i druków szkolnych"
                description="Aktualny cennik legitymacji uczniowskich, legitymacji nauczycielskich, świadectw i druków szkolnych oferowanych przez StrefaDlaEdukacji.pl."
                path="/pricing"
              />
              <ButtonTop />
              <PriceList />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <Seo
                title="strefadlaedukacji.pl - O nas"
                description="Poznaj StrefaDlaEdukacji.pl – firmę wspierającą ze szkołami i placówkami oświatowymi w Polsce, firma strefadlaedukacji.pl wdraża nowoczesne technologie. Dostarcza materiały oraz oferta druku (personalizacji) legitymacji ucznia i służbowej nauczyciela."
                path="/about"
              />
              <Aboutus />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <Seo
                title="strefadlaedukacji.pl - Kontakt"
                description="Skontaktuj się z StrefaDlaEdukacji.pl w sprawie zamówienia legitymacji szkolnych, świadectw lub druków dla Twojej placówki oświatowej."
                path="/contact"
              />
              <ContactForm />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/zamowienie-blankietow"
          element={
            <>
              <Seo
                title="strefadlaedukacji.pl - Formularz zamówienia blankietów e-legitymacji"
                description="Zamów blankiety e-legitymacji szkolnych, legitymacji służbowych nauczyciela i hologramów. Wypełnij formularz zamówienia online StrefaDlaEdukacji.pl."
                path="/zamowienie-blankietow"
              />
              <React.Suspense fallback={null}>
                <OrderForm />
              </React.Suspense>
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/polityka-cookies"
          element={
            <>
              <Seo
                title="strefadlaedukacji.pl -  Polityka cookies"
                description="Polityka wykorzystania plików cookies na stronie StrefaDlaEdukacji.pl."
                path="/polityka-cookies"
              />
              <CookiePolicy />
              <Footer />
            </>
          }
        />
        <Route
          path="/polityka-prywatnosci"
          element={
            <>
              <Seo
                title="strefadlaedukacji.pl - Polityka prywatności"
                description="Polityka prywatności i zasady przetwarzania danych osobowych w StrefaDlaEdukacji.pl."
                path="/polityka-prywatnosci"
              />
              <PrivacyPolicy />
              <Footer />
            </>
          }
        />
        <Route
          path="*"
          element={
            <>
              <Seo
                title="strefadlaedukacji.pl - Nie znaleziono strony"
                description="Strona, której szukasz, nie istnieje. Wróć na stronę główną StrefaDlaEdukacji.pl."
                noindex
              />
              <NotFound />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
